(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["will-production-careers"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  let formsiteScript;
  const loadFormsite = () => {
    if (window.EmbedManager) return Promise.resolve(window.EmbedManager);
    if (!formsiteScript) {
      formsiteScript = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://fs18.formsite.com/include/form/embedManager.js?1824679953';
        script.onload = () => window.EmbedManager ? resolve(window.EmbedManager) : reject(new Error('Formsite unavailable'));
        script.onerror = () => { script.remove(); formsiteScript = null; reject(new Error('Formsite unavailable')); };
        document.head.append(script);
      });
    }
    return formsiteScript;
  };
  const boot = () => document.querySelectorAll('[data-will-careers]').forEach(init);
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    let dictionary = {};
    try { dictionary = JSON.parse(root.querySelector('[data-careers-i18n]')?.textContent || '{}'); } catch (_) {}
    const tr = (text, values = {}) => String(dictionary[text] ?? text).replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
    const life = new AbortController();
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const on = (el, event, fn) => el?.addEventListener(event, fn, {signal:life.signal});
    const embed = $('[data-formsite-embed]');
    if (embed) {
      loadFormsite().then(manager => {
        if (!root.isConnected || life.signal.aborted || embed.querySelector('iframe')) return;
        const key = embed.dataset.formsiteKey;
        const embedId = key.slice(key.indexOf('&') + 1);
        const anchor = embed.querySelector('[data-formsite-anchor]');
        anchor.id = 'formAnchor' + embedId;
        anchor.name = 'form' + embedId;
        manager.embed({key, width:'100%', title:embed.dataset.formsiteTitle});
      }).catch(() => {});
    }
    const menu = $('.menu-toggle');
    const closeMenu = () => {if(!menu)return;menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',tr("Open navigation"));$('#mobile-nav').hidden=true;};
    on(menu,'click',() => {const open=menu.getAttribute('aria-expanded') !== 'true';menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?tr("Close navigation"):tr("Open navigation"));$('#mobile-nav').hidden=!open;});
    $$('.mobile-nav a').forEach(a=>on(a,'click',closeMenu));
    on(root,'keydown',event => {if(event.key === 'Escape')closeMenu();});

    $$('a[href^="#"]').forEach(link => on(link,'click',event => {
      const id = link.getAttribute('href').slice(1); const destination = $(`[id="${id}"]`);
      if(destination){event.preventDefault();destination.scrollIntoView({behavior:'smooth',block:'start'});destination.tabIndex=-1;destination.focus({preventScroll:true});}
    }));
    const videos = {
      overview:{id:root.dataset.overviewVideo || 'aqDK7P6BaGI',title:tr("Inside Wisconsin Lighting Lab")},
      culture:{id:root.dataset.cultureVideo || 'omLtcciFo_o',title:tr("WiLL’s mission: people, ideas, and community")}
    };
    const dialog = $('#will-careers-video-dialog');
    $$('.video-card').forEach(button => on(button,'click',() => {
      const video = videos[button.dataset.video];
      if(!video || !/^[a-zA-Z0-9_-]{11}$/.test(video.id))return;
      $('#will-careers-video-title').textContent=video.title;
      $('#will-careers-youtube-link').href=`https://www.youtube.com/watch?v=${video.id}`;
      const frame=document.createElement('iframe'); frame.src=`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`;
      frame.title=video.title;frame.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
      $('#will-careers-video-container').replaceChildren(frame);dialog.showModal();
    }));
    on($('#will-careers-close-video'),'click',() => dialog.close());
    on(dialog,'close',() => $('#will-careers-video-container').replaceChildren());
    on(dialog,'click',event => {if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
    root._willCleanup = () => {life.abort();if(dialog?.open)dialog.close();};
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-will-careers]').forEach(root=>root._willCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();
})();
